import { addPopupAction } from 'js/components/common/PopupManager';
import { LoginFailedPopup } from './LoginFailedPopup';

export const loginFailedPopupAction = ({ errorCode }) => addPopupAction({
    errorCode,
    closeAll: true,
    component: LoginFailedPopup
});
